import React from "react";

const WHY_CHOOSE_DATA = {
    "school-of-management": { name: "Management", eyebrow: "Leadership advantage", lead: "Build the judgement, confidence and commercial perspective required to lead in complex organisations.", reasons: [["Case-led classrooms", "Analyse business situations, evaluate alternatives and defend decisions."], ["Industry interaction", "Learn through corporate conversations, practitioner insights and current business contexts."], ["Leadership practice", "Strengthen communication, negotiation, teamwork and responsible decision-making."], ["Entrepreneurial mindset", "Transform ideas into viable opportunities through structured venture thinking."], ["Business analytics", "Use evidence, data and financial insight to support managerial decisions."]], signature: "Think strategically. Lead responsibly." },
    "school-of-commerce": { name: "Commerce", eyebrow: "Commercial intelligence", lead: "Connect accounting, finance, taxation and digital commerce with the realities of modern enterprise.", reasons: [["Strong financial foundation", "Build clarity in accounting, economics, banking and business finance."], ["Practice-oriented learning", "Apply commercial concepts through analysis, exercises and business scenarios."], ["Digital commerce exposure", "Understand technology-enabled finance, enterprise systems and digital markets."], ["Professional alignment", "Develop knowledge relevant to finance, taxation and corporate career pathways."], ["Analytical capability", "Interpret financial information and communicate evidence-based conclusions."], ["Ethical commerce", "Understand responsibility, compliance and trust in financial decision-making."]], signature: "Understand value. Create enterprise." },
    "school-of-engineering-and-technology": { name: "Engineering & Technology", eyebrow: "Build what comes next", lead: "Move from engineering principles to prototypes, systems and solutions through technical practice.", reasons: [["Advanced laboratories", "Test engineering concepts using practical equipment, tools and structured experimentation."], ["Design-build projects", "Convert technical ideas into models, prototypes and working solutions."], ["Interdisciplinary learning", "Connect computing, mechanics, electronics, infrastructure and emerging technology."], ["Simulation & analysis", "Use engineering software and analytical methods to evaluate design performance."], ["Industry relevance", "Engage with contemporary engineering practices, applications and workplace expectations."], ["Innovation culture", "Investigate real challenges through teamwork, research and iterative problem-solving."]], signature: "Imagine. Engineer. Improve." },
    "school-of-information-and-technology": { name: "Information & Technology", eyebrow: "Technology without limits", lead: "Learn to architect secure, intelligent and scalable digital systems for a rapidly evolving world.", reasons: [["AI-first learning", "Explore artificial intelligence, machine learning and intelligent automation."], ["Modern technology stack", "Develop capability across software, cloud, data and full-stack environments."], ["Cybersecurity mindset", "Understand secure systems, risk awareness and responsible digital practice."], ["Live coding culture", "Learn through coding labs, technical challenges and collaborative builds."], ["Project portfolio", "Create demonstrable digital products that communicate practical capability."], ["Future-ready pathways", "Prepare for emerging roles across data, AI, cloud and software engineering."]], signature: "Code intelligence into possibility." },
    "school-of-science": { name: "Science", eyebrow: "Discovery through evidence", lead: "Develop scientific confidence through observation, experimentation and research-led investigation.", reasons: [["Laboratory immersion", "Build practical confidence through structured experiments and scientific instrumentation."], ["Research orientation", "Learn to frame questions, examine evidence and communicate defensible findings."], ["Interdisciplinary enquiry", "Connect scientific disciplines to understand complex natural phenomena."], ["Field learning", "Extend classroom knowledge through observation, sampling and applied investigation."], ["Analytical thinking", "Interpret scientific data with precision, logic and intellectual honesty."], ["Academic progression", "Create a strong foundation for research, industry and advanced scientific study."]], signature: "Question deeply. Discover responsibly." },
    "school-of-arts-and-humanities": { name: "Arts & Humanities", eyebrow: "Human understanding", lead: "Study language, culture and society to become a perceptive thinker and powerful communicator.", reasons: [["Critical interpretation", "Examine texts, ideas and social contexts from informed perspectives."], ["Cultural literacy", "Understand diverse histories, identities, traditions and human experiences."], ["Research & writing", "Build disciplined enquiry and clear, persuasive academic expression."], ["Language capability", "Strengthen communication through thoughtful reading, writing and dialogue."], ["Interdisciplinary outlook", "Connect literature, society, psychology, history and contemporary issues."], ["Transferable strengths", "Develop empathy, reasoning and communication valued across professions."]], signature: "Read the world. Shape its conversations." },
    "school-of-law": { name: "Law", eyebrow: "Justice through knowledge", lead: "Develop legal reasoning, ethical judgement and advocacy within a rigorous academic environment.", reasons: [["Moot court practice", "Strengthen legal argument, courtroom confidence and professional presentation."], ["Case-based learning", "Interpret judgements, statutes and legal principles through structured analysis."], ["Clinical exposure", "Understand how law operates through practical and community-oriented engagement."], ["Research & drafting", "Develop precise legal writing, documentation and evidence-based reasoning."], ["Constitutional values", "Ground professional learning in justice, rights, responsibility and public service."], ["Professional preparation", "Build capabilities relevant to litigation, policy, corporate and judicial pathways."]], signature: "Reason with clarity. Advocate with integrity." },
    "school-of-pharmacy": { name: "Pharmacy", eyebrow: "Precision in healthcare", lead: "Combine pharmaceutical knowledge, laboratory discipline and patient responsibility for meaningful health careers.", reasons: [["Formulation laboratories", "Understand dosage forms, preparation methods and pharmaceutical processes."], ["Quality orientation", "Learn the importance of accuracy, validation, standards and patient safety."], ["Drug science", "Study how medicines are discovered, developed, evaluated and responsibly used."], ["Research practice", "Build scientific investigation and documentation through guided laboratory work."], ["Healthcare perspective", "Connect pharmaceutical science with public health and patient wellbeing."]], signature: "Science measured in better health." },
    "school-of-design": { name: "Design", eyebrow: "Creative intelligence", lead: "Develop an individual design voice through observation, experimentation, technology and studio practice.", reasons: [["Studio culture", "Learn in an environment shaped by critique, exploration and creative exchange."], ["Design thinking", "Frame human needs and develop purposeful, evidence-informed solutions."], ["Material exploration", "Understand form, texture, construction and the expressive potential of materials."], ["Digital practice", "Use contemporary tools to visualise, prototype and communicate ideas."], ["Portfolio development", "Build a coherent body of work that demonstrates process and capability."], ["Interdisciplinary projects", "Collaborate across creative and technical contexts to expand design thinking."]], signature: "Observe differently. Design meaningfully." },
    "school-of-education": { name: "Education", eyebrow: "Educators who inspire", lead: "Prepare to create inclusive, engaging and intellectually meaningful learning experiences.", reasons: [["Classroom immersion", "Connect educational theory with observation and guided teaching practice."], ["Reflective pedagogy", "Evaluate how learners develop and how teaching choices influence outcomes."], ["Inclusive education", "Design learning that respects diverse needs, contexts and capabilities."], ["Mentored practice", "Grow through professional feedback, collaboration and reflective improvement."], ["Digital teaching", "Use appropriate educational technologies to enrich learning experiences."], ["Research mindset", "Examine classroom questions through evidence, enquiry and professional reflection."]], signature: "Teach thoughtfully. Transform futures." },
    "school-of-journalism-and-mass-communication": { name: "Journalism & Mass Communication", eyebrow: "Truth. Story. Impact.", lead: "Learn to investigate, verify and communicate stories responsibly across contemporary platforms.", reasons: [["Newsroom practice", "Experience reporting, editing, deadlines and collaborative editorial workflows."], ["Multiplatform production", "Create stories for print, broadcast, audio, video and digital channels."], ["Media ethics", "Understand accuracy, fairness, responsibility and the public role of communication."], ["Field reporting", "Develop observation, interviewing and source-building through practical assignments."], ["Production facilities", "Build confidence with contemporary tools for recording, editing and publishing."], ["Strategic communication", "Explore public relations, campaigns, audience insight and institutional communication."]], signature: "Find facts. Tell stories that matter." },
    "school-of-hotel-management": { name: "Hotel Management", eyebrow: "Excellence in every detail", lead: "Master the operations, service culture and professional confidence behind memorable hospitality.", reasons: [["Operational training", "Practise front office, housekeeping, service and hospitality procedures."], ["Culinary learning", "Develop foundational kitchen discipline, production knowledge and food presentation."], ["Guest experience", "Understand service design, communication and the expectations of diverse guests."], ["Professional grooming", "Build confidence, etiquette, teamwork and workplace-ready presentation."], ["Industry exposure", "Connect academic learning with contemporary hospitality environments."], ["Business understanding", "Learn the commercial, supervisory and entrepreneurial dimensions of hospitality."]], signature: "Professional precision. Genuine hospitality." },
    "school-of-media-and-entertainment": { name: "Media & Entertainment", eyebrow: "Ideas in production", lead: "Transform imagination into screen, stage and digital experiences through collaborative creative practice.", reasons: [["Production culture", "Learn through briefs, rehearsals, shoots, edits and creative delivery cycles."], ["Contemporary storytelling", "Develop original narratives for visual, performance and digital formats."], ["Creative technology", "Use production tools to shape sound, image, motion and audience experiences."], ["Collaborative studios", "Work across roles and disciplines as part of creative production teams."], ["Audience insight", "Understand platforms, formats, engagement and the business of entertainment."], ["Showreel development", "Create finished work that demonstrates creative identity and production capability."]], signature: "Create boldly. Connect emotionally." },
    "school-of-library-and-information-science": { name: "Library & Information Science", eyebrow: "Knowledge made discoverable", lead: "Prepare to organise, preserve and connect trusted knowledge across physical and digital environments.", reasons: [["Knowledge organisation", "Learn classification, cataloguing, metadata and structured information access."], ["Digital libraries", "Understand electronic resources, repositories and technology-enabled services."], ["Information retrieval", "Develop effective strategies for discovering, evaluating and delivering information."], ["Archives & preservation", "Explore responsible stewardship of records, collections and institutional memory."], ["User-centred services", "Design inclusive information experiences around real community needs."], ["Research support", "Build capabilities that help learners and researchers navigate trusted resources."]], signature: "Organise knowledge. Expand access." },
    "school-of-yoga-and-naturopathy": { name: "Yoga & Naturopathy", eyebrow: "Wisdom in practice", lead: "Study holistic wellbeing through disciplined practice, classical knowledge and responsible health understanding.", reasons: [["Guided practice", "Develop consistency, alignment and awareness through structured practical sessions."], ["Classical foundations", "Study the philosophical and historical traditions that inform yoga practice."], ["Holistic wellbeing", "Understand interconnected approaches to physical, mental and emotional balance."], ["Therapeutic awareness", "Explore responsible, context-sensitive applications of yoga and natural wellbeing."], ["Lifestyle education", "Examine habits, nutrition, stress and daily practices that influence wellbeing."], ["Reflective discipline", "Cultivate observation, self-awareness and professional responsibility."]], signature: "Knowledge, balance and disciplined living." },
    "school-of-life-science": { name: "Life Science", eyebrow: "Science of living systems", lead: "Explore life from molecules to ecosystems through biological research and practical investigation.", reasons: [["Modern laboratories", "Investigate biological processes through practical methods and scientific equipment."], ["Molecular understanding", "Study cellular, genetic and biochemical foundations of living systems."], ["Biotechnology exposure", "Connect biological knowledge with contemporary scientific applications."], ["Ecological perspective", "Understand organisms in relation to environment, sustainability and biodiversity."]], signature: "Study life. Advance possibility." },
    "school-of-vocational-management": { name: "Vocational Management", eyebrow: "Learning that performs", lead: "Gain practical capability, professional discipline and industry relevance through learning by doing.", reasons: [["Hands-on instruction", "Build practical confidence through demonstration, practice and applied assignments."], ["Competency assessment", "Show what you can do through observable, workplace-oriented performance."], ["Industry alignment", "Learn skills shaped by current roles, processes and employer expectations."], ["Professional behaviour", "Strengthen communication, reliability, teamwork and workplace discipline."], ["Flexible pathways", "Access learning designed around practical progression and career development."], ["Employment focus", "Connect every stage of learning with usable capability and professional opportunity."]], signature: "Learn a skill. Build a livelihood." },
    "school-of-health-and-allied-science": { name: "Health & Allied Science", eyebrow: "Capability in service of care", lead: "Develop scientific understanding, clinical awareness and ethical responsibility for allied health practice.", reasons: [["Clinical foundations", "Understand the scientific principles supporting diagnosis, care and rehabilitation."], ["Practical training", "Develop disciplined procedures through demonstrations, laboratories and simulations."], ["Patient-centred outlook", "Recognise dignity, communication and responsibility in healthcare environments."], ["Diagnostic awareness", "Learn the value of accurate observation, testing, records and clinical teamwork."]], signature: "Skilled professionals. Healthier communities." }
};

const cx = (...v) => v.filter(Boolean).join(" ");
const Arrow = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-5 w-5" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-5-5 5 5-5 5" /></svg>;
const Icon = ({ index = 0, dark = false }) => <span className={cx("grid h-12 w-12 shrink-0 place-items-center rounded-2xl text-sm font-bold", dark ? "bg-[#D5AD57] text-[#071A2F]" : "bg-[#8B1E3F] text-white")}>{String(index + 1).padStart(2, "0")}</span>;
const Heading = ({ data, dark = false, center = false }) => <header className={cx("max-w-4xl", center && "mx-auto text-center")}><div className={cx("flex items-center gap-4", center && "justify-center")}><span className={cx("h-px w-12", dark ? "bg-[#D5AD57]" : "bg-[#8B1E3F]")} /><span className={cx("text-sm font-bold uppercase tracking-[.16em]", dark ? "text-[#D5AD57]" : "text-[#8B1E3F]")}>{data.eyebrow}</span></div><h2 className={cx("mt-6 text-[clamp(40px,5vw,68px)] font-normal leading-[1.04] tracking-[-.035em]", dark ? "text-white" : "text-[#071A2F]")} style={{ fontFamily: '"Libre Caslon Display",Georgia,serif' }}>Why choose ISBM <em className={cx("font-normal", dark ? "text-[#D5AD57]" : "text-[#8B1E3F]")}>{data.name} School?</em></h2><p className={cx("mt-6 text-base leading-8 sm:text-lg", dark ? "text-white/65" : "text-[#132337]/65")}>{data.lead}</p></header>;
const CTA = ({ dark = false, href = "#academic-programs" }) => <a href={href} className={cx("inline-flex items-center gap-3 rounded-full px-6 py-3.5 text-base font-bold transition hover:-translate-y-1", dark ? "bg-[#D5AD57] text-[#071A2F]" : "bg-[#8B1E3F] text-white")}>Explore programmes <Arrow /></a>;
const Image = ({ src, alt, className = "min-h-[480px]" }) => src ? <img src={src} alt={alt} className={cx("h-full w-full object-cover", className)} /> : <div className={cx("relative overflow-hidden bg-[#0C2744]", className)} role="img" aria-label={`${alt} learning environment`}><div className="absolute inset-0 opacity-20 [background-image:linear-gradient(#D5AD57_1px,transparent_1px),linear-gradient(90deg,#D5AD57_1px,transparent_1px)] [background-size:42px_42px]" /><div className="absolute inset-[18%] rounded-full border border-[#D5AD57]/30" /><div className="absolute inset-[30%] rounded-full border border-[#8B1E3F]/60" /></div>;
const Cards = ({ data, dark = false, numbered = true }) => <div className="grid gap-4 sm:grid-cols-2">{data.reasons.map(([title, text], i) => <article key={title} className={cx("group p-5 transition duration-300", dark ? "border border-white/12 bg-white/[.04] hover:bg-white/[.08]" : "border border-[#071A2F]/10 bg-white hover:-translate-y-1 hover:border-[#D5AD57]")}><div className="flex gap-4">{numbered && <Icon index={i} dark={dark} />}<div><h3 className={cx("text-lg font-semibold", dark ? "text-white" : "text-[#071A2F]")}>{title}</h3><p className={cx("mt-2 text-sm leading-7", dark ? "text-white/60" : "text-[#132337]/60")}>{text}</p></div></div></article>)}</div>;
const Shell = ({ children, bg = "bg-white", pattern = false }) => <section className={cx("relative overflow-hidden py-20 sm:py-24 lg:py-28", bg)}>{pattern && <div className="pointer-events-none absolute inset-0 opacity-30 [background-image:radial-gradient(#071A2F_1px,transparent_1px)] [background-size:30px_30px]" />}<div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">{children}</div></section>;

function Management({ data, image, href }) { return <Shell bg="bg-white"><div className="grid gap-10 lg:grid-cols-[.82fr_1.18fr]"><div><Heading data={data} /><blockquote className="mt-9 border-l-4 border-[#D5AD57] pl-6 text-2xl leading-9 text-[#071A2F]">{data.signature}</blockquote><div className="mt-9"><CTA href={href} /></div></div><div className="grid gap-4 sm:grid-cols-2">{data.reasons.map(([t, d], i) => <article key={t} className={cx("rounded-[26px] p-6", i === 0 ? "bg-[#071A2F] text-white sm:col-span-2" : "border border-[#071A2F]/10 bg-[#F7F2E8] text-[#071A2F]")}><span className={cx("text-sm font-bold", i === 0 ? "text-[#D5AD57]" : "text-[#8B1E3F]")}>0{i + 1}</span><h3 className="mt-5 text-xl font-semibold">{t}</h3><p className={cx("mt-3 text-sm leading-7", i === 0 ? "text-white/65" : "text-[#132337]/60")}>{d}</p></article>)}</div></div></Shell> }
function Commerce({ data, image, href }) {
    const commerceAdvantages = data.reasons.map(
        ([title, text], index) => [
            String(index + 1).padStart(2, "0"),
            title,
            text,
        ]
    );

    return (
        <section
            className="relative overflow-hidden bg-[#EEE5D3] py-20 sm:py-24 lg:py-28"
            aria-labelledby="commerce-advantage-heading"
        >
            {/* Decorative background */}
            <div
                className="pointer-events-none absolute inset-0"
                aria-hidden="true"
            >
                <div className="absolute -left-40 top-16 h-[460px] w-[460px] rounded-full bg-[#D5AD57]/15 blur-[100px]" />

                <div className="absolute -right-48 bottom-0 h-[540px] w-[540px] rounded-full border-[90px] border-[#8B1E3F]/[0.035]" />

                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D5AD57] to-transparent" />
            </div>

            <div className="relative mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                {/* Section heading */}
                <header className="max-w-4xl">
                    <div className="flex items-center gap-4">
                        <span className="h-px w-12 bg-[#8B1E3F]" />

                        <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                            The ISBM commerce advantage
                        </span>
                    </div>

                    <h2
                        id="commerce-advantage-heading"
                        className="mt-6 text-[clamp(40px,5vw,68px)] font-normal leading-[1.04] tracking-[-0.035em] text-[#071A2F]"
                        style={{
                            fontFamily:
                                '"Libre Caslon Display", Georgia, serif',
                        }}
                    >
                        Why choose ISBM
                        <em className="font-normal text-[#8B1E3F]">
                            {" "}
                            Commerce School?
                        </em>
                    </h2>

                    <p className="mt-6 max-w-3xl text-base leading-8 text-[#132337]/65 sm:text-lg">
                        A commerce education that balances disciplinary
                        depth, contemporary tools, professional exposure and
                        responsible decision-making.
                    </p>
                </header>

                {/* Commerce advantages */}
                <div className="mt-14 grid border-t-2 border-[#071A2F] lg:grid-cols-[320px_1fr]">
                    {/* Graduate proposition */}
                    <aside className="relative overflow-hidden bg-[#8B1E3F] p-8 text-white lg:min-h-[720px] lg:p-10">
                        <div
                            className="pointer-events-none absolute -right-20 -top-20 h-60 w-60 rounded-full border-[45px] border-white/[0.05]"
                            aria-hidden="true"
                        />

                        <div
                            className="pointer-events-none absolute -bottom-24 -left-20 h-64 w-64 rounded-full bg-[#071A2F]/30 blur-[60px]"
                            aria-hidden="true"
                        />

                        <div className="relative flex h-full flex-col">
                            <span className="text-sm font-bold uppercase tracking-[0.14em] text-white/65">
                                The graduate proposition
                            </span>

                            <p
                                className="mt-8 text-4xl leading-[1.25]"
                                style={{
                                    fontFamily:
                                        '"Libre Caslon Display", Georgia, serif',
                                }}
                            >
                                Understand value. Interpret change. Lead
                                enterprise responsibly.
                            </p>

                            <div className="mt-10 h-px bg-white/25" />

                            <p className="mt-8 text-base leading-8 text-white/70">
                                Students develop commercial awareness through
                                disciplined study, practical application and
                                engagement with contemporary business realities.
                            </p>

                            <blockquote className="mt-10 border-l-2 border-[#D5AD57] pl-5 text-xl leading-8 text-white">
                                “{data.signature}”
                            </blockquote>

                            <div className="mt-auto pt-10">
                                <CTA dark href={href} />
                            </div>
                        </div>
                    </aside>

                    {/* Advantage register */}
                    <div className="border-r border-[#071A2F]/20">
                        {commerceAdvantages.map(
                            ([number, title, text], index) => (
                                <article
                                    key={number}
                                    className="group relative grid min-h-28 overflow-hidden border-b border-[#071A2F]/20 bg-white transition duration-300 hover:bg-[#F9F3F5] md:grid-cols-[76px_1fr_220px]"
                                >
                                    <div className="flex items-center px-5 text-sm font-extrabold text-[#8B1E3F] md:border-r md:border-[#071A2F]/15">
                                        {number}
                                    </div>

                                    <div className="px-5 py-6 md:px-8">
                                        <h3
                                            className="text-2xl font-normal text-[#071A2F] transition duration-300 group-hover:text-[#8B1E3F]"
                                            style={{
                                                fontFamily:
                                                    '"Libre Caslon Display", Georgia, serif',
                                            }}
                                        >
                                            {title}
                                        </h3>

                                        <p className="mt-2 text-base leading-7 text-[#65717D]">
                                            {text}
                                        </p>
                                    </div>

                                    {/* Outcome label */}
                                    <div className="flex items-center border-t border-[#071A2F]/10 px-5 py-5 md:border-l md:border-t-0 md:px-7">
                                        <div>
                                            <span className="text-sm font-bold uppercase tracking-[0.11em] text-[#8B1E3F]">
                                                Student advantage
                                            </span>

                                            <span className="mt-2 block text-sm leading-6 text-[#65717D]">
                                                {index === 0 &&
                                                    "Commercial understanding"}
                                                {index === 1 &&
                                                    "Practical application"}
                                                {index === 2 &&
                                                    "Digital capability"}
                                                {index === 3 &&
                                                    "Professional readiness"}
                                                {index === 4 &&
                                                    "Analytical confidence"}
                                                {index === 5 &&
                                                    "Responsible judgement"}
                                            </span>
                                        </div>
                                    </div>

                                    <span className="absolute inset-y-0 left-0 w-1 origin-bottom scale-y-0 bg-[#D5AD57] transition duration-300 group-hover:scale-y-100" />
                                </article>
                            )
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
function Engineering({ data, image, href }) {
    const [activeEngineeringAdvantage, setActiveEngineeringAdvantage] =
        React.useState(0);

    const engineeringHighlights = [
        ["Modern equipment", "Guided experiments", "Technical practice"],
        ["Models and prototypes", "Design process", "Problem solving"],
        ["Connected disciplines", "Collaborative projects", "Systems thinking"],
        ["Engineering software", "Simulation tools", "Performance analysis"],
        ["Industry practices", "Professional exposure", "Career readiness"],
        ["Research culture", "Team innovation", "Iterative development"],
    ];

    const engineeringStatuses = [
        "Laboratory environment enabled",
        "Design and prototyping enabled",
        "Interdisciplinary learning enabled",
        "Simulation environment enabled",
        "Industry engagement enabled",
        "Innovation ecosystem enabled",
    ];

    const engineeringAdvantages = data.reasons.map(
        ([title, description], index) => ({
            number: String(index + 1).padStart(2, "0"),
            short: title,
            title,
            description,
            highlights:
                engineeringHighlights[index] || [
                    "Applied learning",
                    "Technical capability",
                    "Professional development",
                ],
            status:
                engineeringStatuses[index] ||
                "Engineering pathway enabled",
        })
    );

    const selectedEngineeringAdvantage =
        engineeringAdvantages[
        Math.min(
            activeEngineeringAdvantage,
            Math.max(engineeringAdvantages.length - 1, 0)
        )
        ];

    if (!selectedEngineeringAdvantage) return null;

    return (
        <section
            className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-32"
            aria-labelledby="why-engineering-heading"
        >
            {/* Background engineering details */}
            <div
                className="pointer-events-none absolute inset-0"
                aria-hidden="true"
            >
                <div className="absolute -left-52 top-20 h-[520px] w-[520px] rounded-full bg-[#8B1E3F]/[0.055] blur-[120px]" />

                <div className="absolute -bottom-60 right-[-10%] h-[600px] w-[600px] rounded-full bg-[#D5AD57]/15 blur-[130px]" />

                <div className="absolute inset-0 opacity-[0.025] [background-image:linear-gradient(#071A2F_1px,transparent_1px),linear-gradient(90deg,#071A2F_1px,transparent_1px)] [background-size:52px_52px]" />

                <svg
                    viewBox="0 0 900 700"
                    fill="none"
                    className="absolute right-0 top-0 h-full w-1/2 text-[#071A2F] opacity-[0.035]"
                >
                    <path
                        d="M80 40v120h160l80 80h180l100-100h220M320 240v140l90 90h220M410 470v140M600 140V40"
                        stroke="currentColor"
                        strokeWidth="2"
                    />

                    <circle
                        cx="240"
                        cy="160"
                        r="8"
                        fill="currentColor"
                    />

                    <circle
                        cx="320"
                        cy="240"
                        r="8"
                        fill="currentColor"
                    />

                    <circle
                        cx="500"
                        cy="240"
                        r="8"
                        fill="currentColor"
                    />

                    <circle
                        cx="410"
                        cy="470"
                        r="8"
                        fill="currentColor"
                    />

                    <circle
                        cx="630"
                        cy="470"
                        r="8"
                        fill="currentColor"
                    />
                </svg>
            </div>

            <div className="relative mx-auto max-w-[1380px] px-5 sm:px-8 lg:px-10">
                {/* Section heading */}
                <div className="grid gap-8 lg:grid-cols-[1fr_0.62fr] lg:items-end">
                    <div>
                        <div className="flex items-center gap-4">
                            <span className="h-px w-10 bg-[#8B1E3F]" />

                            <span className="text-sm font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">
                                The ISBM engineering advantage
                            </span>
                        </div>

                        <h2
                            id="why-engineering-heading"
                            className="mt-6 max-w-5xl text-[clamp(42px,5vw,72px)] font-normal leading-[1.03] tracking-[-0.045em] text-[#071A2F]"
                            style={{
                                fontFamily:
                                    '"Libre Caslon Display", Georgia, serif',
                            }}
                        >
                            Why choose ISBM
                            <em className="font-normal text-[#8B1E3F]">
                                {" "}
                                Engineering &amp; Technology School?
                            </em>
                        </h2>
                    </div>

                    <div className="lg:pb-2">
                        <p className="max-w-xl text-base leading-8 text-[#132337]/65 sm:text-lg">
                            {data.lead ||
                                "An engineering education shaped around strong fundamentals, applied learning, innovation, professional exposure and responsible technological progress."}
                        </p>

                        <div className="mt-7">
                            <CTA href={href} />
                        </div>
                    </div>
                </div>

                {/* Interactive engineering ecosystem */}
                <div className="mt-14 overflow-hidden rounded-[34px] border border-[#071A2F]/10 bg-[#071A2F] shadow-[0_35px_100px_rgba(7,26,47,0.18)]">
                    <div className="grid lg:grid-cols-[1.12fr_0.88fr]">
                        {/* Engineering visual */}
                        <div className="relative min-h-[620px] overflow-hidden sm:min-h-[700px] lg:min-h-[760px]">
                            <Image
                                src={image}
                                alt={`${data.name} engineering learning environment`}
                                className="min-h-[620px] sm:min-h-[700px] lg:min-h-[760px]"
                            />

                            <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F] via-[#071A2F]/35 to-[#071A2F]/10" />

                            <div className="absolute inset-0 bg-gradient-to-r from-[#071A2F]/20 via-transparent to-[#071A2F]/60" />

                            {/* Scanning line */}
                            <div className="absolute inset-x-0 top-[36%] h-px bg-gradient-to-r from-transparent via-[#D5AD57]/70 to-transparent shadow-[0_0_18px_rgba(213,173,87,0.7)]" />

                            {/* Interface corners */}
                            <span className="absolute left-6 top-6 h-10 w-10 border-l border-t border-[#D5AD57]/60" />

                            <span className="absolute right-6 top-6 h-10 w-10 border-r border-t border-[#D5AD57]/60" />

                            <span className="absolute bottom-6 left-6 h-10 w-10 border-b border-l border-[#D5AD57]/60" />

                            <span className="absolute bottom-6 right-6 h-10 w-10 border-b border-r border-[#D5AD57]/60" />

                            {/* System status */}
                            <div className="absolute left-6 right-6 top-6 flex items-center justify-between sm:left-8 sm:right-8 sm:top-8">
                                <span className="inline-flex items-center gap-3 rounded-full border border-white/15 bg-[#071A2F]/65 px-4 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-[#D5AD57] backdrop-blur-xl">
                                    <span className="relative flex h-2.5 w-2.5">
                                        <span className="absolute h-full w-full animate-ping rounded-full bg-[#D5AD57] opacity-70 motion-reduce:animate-none" />

                                        <span className="relative h-2.5 w-2.5 rounded-full bg-[#D5AD57]" />
                                    </span>

                                    Engineering ecosystem active
                                </span>

                                <span className="hidden text-xs font-bold uppercase tracking-[0.14em] text-white/45 sm:block">
                                    ISBM / SET /{" "}
                                    {selectedEngineeringAdvantage.number}
                                </span>
                            </div>

                            {/* Active advantage */}
                            <div className="absolute inset-x-0 bottom-0 p-6 sm:p-9 lg:p-12">
                                <div className="max-w-2xl rounded-[28px] border border-white/15 bg-[#071A2F]/80 p-6 text-white shadow-[0_25px_70px_rgba(0,0,0,0.35)] backdrop-blur-xl sm:p-8">
                                    <div className="flex items-center justify-between gap-5">
                                        <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                            {
                                                selectedEngineeringAdvantage.short
                                            }
                                        </span>

                                        <span
                                            className="text-5xl font-normal leading-none text-white/15"
                                            style={{
                                                fontFamily:
                                                    '"Libre Caslon Display", Georgia, serif',
                                            }}
                                        >
                                            {
                                                selectedEngineeringAdvantage.number
                                            }
                                        </span>
                                    </div>

                                    <h3
                                        className="mt-5 text-3xl font-normal leading-tight sm:text-4xl"
                                        style={{
                                            fontFamily:
                                                '"Libre Caslon Display", Georgia, serif',
                                        }}
                                    >
                                        {
                                            selectedEngineeringAdvantage.title
                                        }
                                    </h3>

                                    <p className="mt-5 text-sm leading-7 text-white/65 sm:text-base sm:leading-8">
                                        {
                                            selectedEngineeringAdvantage.description
                                        }
                                    </p>

                                    <div className="mt-7 flex flex-wrap gap-2">
                                        {selectedEngineeringAdvantage.highlights.map(
                                            (highlight) => (
                                                <span
                                                    key={highlight}
                                                    className="rounded-full border border-white/15 bg-white/[0.06] px-4 py-2 text-xs font-bold uppercase tracking-[0.1em] text-white/70"
                                                >
                                                    {highlight}
                                                </span>
                                            )
                                        )}
                                    </div>

                                    <div className="mt-7 flex items-center gap-4 border-t border-white/10 pt-6">
                                        <span className="h-2.5 w-2.5 rounded-full bg-[#D5AD57] shadow-[0_0_14px_rgba(213,173,87,0.8)]" />

                                        <span className="text-xs font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                                            {
                                                selectedEngineeringAdvantage.status
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Interactive selectors */}
                        <div className="border-t border-white/10 bg-[#071A2F] lg:border-l lg:border-t-0">
                            <div className="border-b border-white/10 p-6 sm:p-8">
                                <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                    Select an advantage
                                </span>

                                <p
                                    className="mt-3 text-2xl font-normal leading-8 text-white"
                                    style={{
                                        fontFamily:
                                            '"Libre Caslon Display", Georgia, serif',
                                    }}
                                >
                                    Explore the environment behind every ISBM
                                    engineer.
                                </p>
                            </div>

                            <div
                                className="grid sm:grid-cols-2 lg:grid-cols-1"
                                role="tablist"
                                aria-label="ISBM Engineering advantages"
                            >
                                {engineeringAdvantages.map(
                                    (advantage, index) => {
                                        const isActive =
                                            activeEngineeringAdvantage === index;

                                        return (
                                            <button
                                                key={advantage.number}
                                                type="button"
                                                role="tab"
                                                aria-selected={isActive}
                                                onClick={() =>
                                                    setActiveEngineeringAdvantage(
                                                        index
                                                    )
                                                }
                                                className={`group relative flex min-h-[105px] items-center gap-5 border-b border-white/10 p-5 text-left transition duration-300 sm:p-6 ${index % 2 === 0
                                                    ? "sm:border-r lg:border-r-0"
                                                    : ""
                                                    } ${isActive
                                                        ? "bg-[#8B1E3F] text-white"
                                                        : "bg-transparent text-white hover:bg-white/[0.055]"
                                                    }`}
                                            >
                                                <span
                                                    className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full border text-sm font-bold transition duration-300 ${isActive
                                                        ? "border-[#D5AD57] bg-[#D5AD57] text-[#071A2F]"
                                                        : "border-white/15 bg-white/[0.05] text-[#D5AD57] group-hover:border-[#D5AD57]/60"
                                                        }`}
                                                >
                                                    {advantage.number}
                                                </span>

                                                <span className="min-w-0">
                                                    <span
                                                        className={`block text-xs font-bold uppercase tracking-[0.14em] ${isActive
                                                            ? "text-[#D5AD57]"
                                                            : "text-white/40"
                                                            }`}
                                                    >
                                                        Engineering advantage
                                                    </span>

                                                    <strong className="mt-2 block text-base font-semibold leading-6">
                                                        {advantage.short}
                                                    </strong>
                                                </span>

                                                <svg
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="1.8"
                                                    className={`ml-auto h-4 w-4 shrink-0 transition duration-300 ${isActive
                                                        ? "translate-x-1 text-[#D5AD57]"
                                                        : "text-white/25 group-hover:translate-x-1 group-hover:text-[#D5AD57]"
                                                        }`}
                                                    aria-hidden="true"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M5 12h14m-5-5 5 5-5 5"
                                                    />
                                                </svg>

                                                {isActive && (
                                                    <span className="absolute bottom-0 left-0 h-[3px] w-full bg-[#D5AD57]" />
                                                )}
                                            </button>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Engineering learning pathway */}
                <div className="mt-8 grid overflow-hidden rounded-[26px] border border-[#071A2F]/10 bg-[#F7F2E8] sm:grid-cols-2 lg:grid-cols-4">
                    {[
                        {
                            number: "01",
                            title: "Understand",
                            text: "Build scientific and engineering foundations.",
                        },
                        {
                            number: "02",
                            title: "Design",
                            text: "Transform ideas into structured technical solutions.",
                        },
                        {
                            number: "03",
                            title: "Construct",
                            text: "Develop, test and improve working systems.",
                        },
                        {
                            number: "04",
                            title: "Advance",
                            text: "Apply engineering knowledge for meaningful impact.",
                        },
                    ].map((stage, index) => (
                        <div
                            key={stage.title}
                            className={`group relative p-6 transition duration-300 hover:bg-white sm:p-7 ${index < 3
                                ? "border-b border-[#071A2F]/10 sm:border-r lg:border-b-0"
                                : ""
                                } ${index === 1
                                    ? "sm:border-r-0 lg:border-r"
                                    : ""
                                }`}
                        >
                            <span className="text-sm font-bold text-[#8B1E3F]">
                                {stage.number}
                            </span>

                            <h3
                                className="mt-4 text-2xl font-normal text-[#071A2F]"
                                style={{
                                    fontFamily:
                                        '"Libre Caslon Display", Georgia, serif',
                                }}
                            >
                                {stage.title}
                            </h3>

                            <p className="mt-3 text-sm leading-7 text-[#132337]/55">
                                {stage.text}
                            </p>

                            <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-gradient-to-r from-[#8B1E3F] to-[#D5AD57] transition-all duration-300 group-hover:w-full" />
                        </div>
                    ))}
                </div>

                {/* Signature statement */}
                <div className="mt-8 flex flex-col gap-6 border-t border-[#071A2F]/15 pt-8 sm:flex-row sm:items-center sm:justify-between">
                    <p
                        className="text-2xl text-[#071A2F]"
                        style={{
                            fontFamily:
                                '"Libre Caslon Display", Georgia, serif',
                        }}
                    >
                        {data.signature}
                    </p>

                    <CTA href={href} />
                </div>
            </div>
        </section>
    );
}
function IT({ data, image, href }) {
    const technologyMetadata = [
        {
            focus: "Intelligent technologies",
            tags: ["Artificial Intelligence", "Machine Learning"],
            icon: (
                <>
                    <circle cx="12" cy="12" r="3" />
                    <path
                        strokeLinecap="round"
                        d="M12 3v3m0 12v3M3 12h3m12 0h3M5.6 5.6l2.1 2.1m8.6 8.6 2.1 2.1m0-12.8-2.1 2.1m-8.6 8.6-2.1 2.1"
                    />
                </>
            ),
        },
        {
            focus: "Modern technology stack",
            tags: ["Software", "Cloud", "Full Stack"],
            icon: (
                <>
                    <rect x="3" y="4" width="18" height="13" rx="2" />
                    <path
                        strokeLinecap="round"
                        d="M8 21h8m-4-4v4"
                    />
                </>
            ),
        },
        {
            focus: "Secure digital systems",
            tags: ["Cybersecurity", "Networks", "Privacy"],
            icon: (
                <>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 3 5 6v5c0 4.6 2.8 8.2 7 10 4.2-1.8 7-5.4 7-10V6l-7-3Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m9.5 12 1.7 1.7 3.7-4"
                    />
                </>
            ),
        },
        {
            focus: "Applied coding culture",
            tags: ["Programming", "Development", "Projects"],
            icon: (
                <>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m8 9-4 3 4 3m8-6 4 3-4 3"
                    />
                    <path
                        strokeLinecap="round"
                        d="m14 5-4 14"
                    />
                </>
            ),
        },
        {
            focus: "Portfolio development",
            tags: ["Products", "Research", "Innovation"],
            icon: (
                <>
                    <rect x="4" y="7" width="16" height="12" rx="2" />
                    <path
                        strokeLinecap="round"
                        d="M9 7V5h6v2m-11 5h16"
                    />
                </>
            ),
        },
        {
            focus: "Technology careers",
            tags: ["Industry", "Careers", "Future Skills"],
            icon: (
                <>
                    <circle cx="12" cy="8" r="3" />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 21c.8-4 3.1-6 7-6s6.2 2 7 6"
                    />
                </>
            ),
        },
    ];

    const technologyAdvantages = data.reasons.map(
        ([title, description], index) => ({
            number: String(index + 1).padStart(2, "0"),
            title,
            description,
            focus:
                technologyMetadata[index]?.focus ||
                "Technology advantage",
            tags: technologyMetadata[index]?.tags || [
                "Applied learning",
                "Technical capability",
            ],
            icon: technologyMetadata[index]?.icon,
        })
    );

    return (
        <section
            className="relative overflow-hidden bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28"
            aria-labelledby="why-it-heading"
        >
            {/* Background decoration */}
            <div
                className="pointer-events-none absolute inset-0 opacity-40"
                aria-hidden="true"
            >
                <div className="absolute -right-40 -top-40 h-[560px] w-[560px] rounded-full border border-[#D5AD57]/15" />

                <div className="absolute -right-20 -top-20 h-[360px] w-[360px] rounded-full border border-white/[0.06]" />

                <div className="absolute -bottom-40 -left-40 h-[440px] w-[440px] rounded-full bg-[#8B1E3F]/20 blur-[100px]" />

                <svg
                    viewBox="0 0 600 600"
                    className="absolute right-0 top-0 h-full w-1/2 opacity-[0.07]"
                    fill="none"
                >
                    <path
                        d="M40 100H180V190H300V85H440V220H550"
                        stroke="#D5AD57"
                        strokeWidth="1"
                    />

                    <path
                        d="M80 340H220V280H370V400H540"
                        stroke="#FFFFFF"
                        strokeWidth="1"
                    />

                    <path
                        d="M150 520V430H300V500H470V350"
                        stroke="#D5AD57"
                        strokeWidth="1"
                    />

                    <circle
                        cx="180"
                        cy="190"
                        r="5"
                        fill="#D5AD57"
                    />

                    <circle
                        cx="300"
                        cy="85"
                        r="5"
                        fill="#D5AD57"
                    />

                    <circle
                        cx="370"
                        cy="400"
                        r="5"
                        fill="#FFFFFF"
                    />

                    <circle
                        cx="470"
                        cy="350"
                        r="5"
                        fill="#D5AD57"
                    />
                </svg>
            </div>

            <div className="relative mx-auto w-[calc(100%-32px)] max-w-[1380px] sm:w-[calc(100%-48px)]">
                {/* Heading */}
                <div className="grid gap-10 lg:grid-cols-[1.08fr_0.92fr] lg:items-end lg:gap-24">
                    <div>
                        <div className="mb-6 flex items-center gap-3 text-[#D5AD57]">
                            <span className="h-[2px] w-[38px] bg-current" />

                            <span className="text-sm font-extrabold uppercase tracking-[0.16em]">
                                Why study with us
                            </span>
                        </div>

                        <h2
                            id="why-it-heading"
                            className="text-[42px] font-normal leading-[1.06] tracking-[-0.035em] sm:text-5xl lg:text-[64px] xl:text-[72px]"
                            style={{
                                fontFamily:
                                    '"Libre Caslon Display", Georgia, serif',
                            }}
                        >
                            Why choose ISBM
                            <em className="mt-2 block font-normal text-[#D5AD57]">
                                Information &amp; Technology School?
                            </em>
                        </h2>
                    </div>

                    <div className="border-l border-white/15 pl-6 sm:pl-8">
                        <p className="text-base leading-8 text-white/65 sm:text-lg">
                            {data.lead ||
                                "Choose an academic environment that combines computing fundamentals, advanced technology specialisations and practical learning to develop relevant capabilities for innovation and professional careers."}
                        </p>

                        <a
                            href={href}
                            className="group mt-7 inline-flex items-center gap-4 text-sm font-extrabold uppercase tracking-[0.14em] text-[#D5AD57]"
                        >
                            Explore academic programmes

                            <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#D5AD57]/40 transition duration-300 group-hover:bg-[#D5AD57] group-hover:text-[#071A2F]">
                                <Arrow className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                            </span>
                        </a>
                    </div>
                </div>

                {/* Key differentiators */}
                <div className="mt-16 grid border-l border-t border-white/10 md:grid-cols-2 lg:mt-20 lg:grid-cols-3">
                    {technologyAdvantages.map((item) => (
                        <article
                            key={item.number}
                            className="group relative flex min-h-[370px] flex-col overflow-hidden border-b border-r border-white/10 p-7 transition duration-500 hover:bg-white/[0.055] sm:p-8 lg:p-9"
                        >
                            {/* Hover accent */}
                            <span className="absolute left-0 top-0 h-0.5 w-0 bg-[#D5AD57] transition-all duration-500 group-hover:w-full" />

                            <div className="flex items-start justify-between">
                                <span className="text-sm font-extrabold tracking-[0.18em] text-white/30">
                                    {item.number}
                                </span>

                                <span className="flex h-12 w-12 items-center justify-center rounded-full border border-white/15 text-[#D5AD57] transition duration-500 group-hover:border-[#D5AD57] group-hover:bg-[#D5AD57] group-hover:text-[#071A2F]">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                    >
                                        {item.icon || (
                                            <>
                                                <circle cx="12" cy="12" r="8" />
                                                <path
                                                    strokeLinecap="round"
                                                    d="M8 12h8m-4-4v8"
                                                />
                                            </>
                                        )}
                                    </svg>
                                </span>
                            </div>

                            <div className="mt-10">
                                <span className="text-xs font-extrabold uppercase tracking-[0.16em] text-[#D5AD57]">
                                    {item.focus}
                                </span>

                                <h3
                                    className="mt-4 text-[27px] font-normal leading-[1.18] text-white"
                                    style={{
                                        fontFamily:
                                            '"Libre Caslon Display", Georgia, serif',
                                    }}
                                >
                                    {item.title}
                                </h3>

                                <p className="mt-4 text-sm leading-7 text-white/55">
                                    {item.description}
                                </p>
                            </div>

                            <div className="mt-auto flex flex-wrap gap-2 pt-7">
                                {item.tags.map((tag) => (
                                    <span
                                        key={tag}
                                        className="rounded-full border border-white/10 bg-white/[0.035] px-3 py-2 text-xs font-bold uppercase tracking-[0.08em] text-white/55 transition group-hover:border-[#D5AD57]/30 group-hover:text-[#D5AD57]"
                                    >
                                        {tag}
                                    </span>
                                ))}
                            </div>
                        </article>
                    ))}
                </div>

                {/* Technology pathway */}
                <div className="grid overflow-hidden border-x border-b border-white/10 lg:grid-cols-[0.72fr_1.28fr]">
                    <div className="bg-[#8B1E3F] px-7 py-8 sm:px-9">
                        <span className="text-xs font-extrabold uppercase tracking-[0.16em] text-[#E8C97E]">
                            A complete technology pathway
                        </span>

                        <p
                            className="mt-3 text-2xl font-normal leading-snug text-white"
                            style={{
                                fontFamily:
                                    '"Libre Caslon Display", Georgia, serif',
                            }}
                        >
                            Begin with fundamentals. Progress towards
                            specialisation.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 bg-white/[0.035] sm:grid-cols-4">
                        {[
                            ["01", "Understand"],
                            ["02", "Practise"],
                            ["03", "Specialise"],
                            ["04", "Progress"],
                        ].map(([number, title]) => (
                            <div
                                key={number}
                                className="border-b border-r border-white/10 px-5 py-7 last:border-r-0 sm:border-b-0 sm:px-7"
                            >
                                <span className="text-xs font-bold tracking-[0.16em] text-[#D5AD57]">
                                    {number}
                                </span>

                                <strong className="mt-2 block text-sm font-semibold text-white">
                                    {title}
                                </strong>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Signature and CTA */}
                <div className="mt-8 flex flex-col gap-6 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
                    <p
                        className="text-2xl text-white"
                        style={{
                            fontFamily:
                                '"Libre Caslon Display", Georgia, serif',
                        }}
                    >
                        {data.signature}
                    </p>

                    <CTA dark href={href} />
                </div>
            </div>
        </section>
    );
}
function Science({ data, image, href }) { return <Shell bg="bg-white"><div className="mx-auto max-w-4xl text-center"><Heading data={data} center /></div><div className="relative mt-14 grid gap-6 lg:grid-cols-[1fr_300px_1fr] lg:items-center"><div className="space-y-4">{data.reasons.slice(0, 3).map(([t, d], i) => <ReasonLine key={t} t={t} d={d} i={i} />)}</div><div className="mx-auto aspect-square w-full max-w-[300px] overflow-hidden rounded-full border-[14px] border-[#F7F2E8]"><Image src={image} alt={data.name} className="min-h-full" /></div><div className="space-y-4">{data.reasons.slice(3).map(([t, d], i) => <ReasonLine key={t} t={t} d={d} i={i + 3} />)}</div></div><div className="mt-10 text-center"><p className="mb-6 text-xl font-semibold text-[#071A2F]">{data.signature}</p><CTA href={href} /></div></Shell> }
function ReasonLine({ t, d, i }) { return <article className="border-b border-[#071A2F]/10 pb-4"><span className="text-sm font-bold text-[#8B1E3F]">Experiment 0{i + 1}</span><h3 className="mt-2 text-lg font-semibold text-[#071A2F]">{t}</h3><p className="mt-2 text-sm leading-7 text-[#132337]/60">{d}</p></article> }
function Arts({ data, image, href }) { return <Shell bg="bg-[#F4E8EC]"><div className="grid gap-10 lg:grid-cols-[.75fr_1.25fr]"><aside className="border-l-4 border-[#8B1E3F] bg-white p-7 sm:p-9"><span className="font-serif text-8xl leading-none text-[#8B1E3F]/15">“</span><p className="-mt-5 text-2xl leading-9 text-[#071A2F]">{data.signature}</p><div className="mt-9"><CTA href={href} /></div></aside><div><Heading data={data} /><div className="mt-10 divide-y divide-[#071A2F]/15 border-y border-[#071A2F]/15">{data.reasons.map(([t, d], i) => <article key={t} className="grid gap-3 py-5 sm:grid-cols-[70px_210px_1fr]"><span className="font-serif text-2xl text-[#A77B2D]">0{i + 1}</span><h3 className="text-lg font-semibold text-[#071A2F]">{t}</h3><p className="text-sm leading-7 text-[#132337]/60">{d}</p></article>)}</div></div></div></Shell> }
function Law({ data, image, href }) { return <Shell bg="bg-white"><div className="border-t-8 border-[#8B1E3F] shadow-[0_24px_70px_rgba(7,26,47,.09)]"><div className="grid lg:grid-cols-[280px_1fr]"><aside className="bg-[#F7F2E8] p-7 sm:p-9"><span className="font-serif text-7xl text-[#8B1E3F]">§</span><p className="mt-8 text-xl leading-8 text-[#071A2F]">{data.signature}</p><div className="mt-9"><CTA href={href} /></div></aside><div className="p-7 sm:p-10 lg:p-12"><Heading data={data} /><div className="mt-9 grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">{data.reasons.map(([t, d], i) => <article key={t} className="bg-white p-5"><span className="text-sm font-bold text-[#8B1E3F]">Article {i + 1}</span><h3 className="mt-3 text-lg font-semibold text-[#071A2F]">{t}</h3><p className="mt-2 text-sm leading-7 text-[#132337]/60">{d}</p></article>)}</div></div></div></div></Shell> }
function Pharmacy({ data, image, href }) { return <Shell bg="bg-white"><div className="grid gap-10 lg:grid-cols-2 lg:items-center"><div><Heading data={data} /><p className="mt-8 rounded-2xl bg-[#8B1E3F] p-6 text-xl font-semibold text-white">{data.signature}</p><div className="mt-8"><CTA href={href} /></div></div><div className="relative grid grid-cols-2 gap-4">{data.reasons.map(([t, d], i) => <article key={t} className={cx("rounded-[28px] border border-[#8B1E3F]/15 bg-white p-5", i === 0 && "col-span-2")}><span className="grid h-10 w-10 place-items-center rounded-full bg-[#8B1E3F] text-sm font-bold text-white">Rx</span><h3 className="mt-4 text-lg font-semibold text-[#071A2F]">{t}</h3><p className="mt-2 text-sm leading-7 text-[#132337]/60">{d}</p></article>)}</div></div></Shell> }
function Design({ data, image, href }) { return <Shell bg="bg-white"><div className="grid gap-4 lg:grid-cols-12"><div className="rounded-[32px] bg-[#D5AD57] p-7 sm:p-10 lg:col-span-7"><Heading data={data} /></div><div className="overflow-hidden rounded-[32px] lg:col-span-5"><Image src={image} alt={data.name} className="min-h-[360px]" /></div>{data.reasons.map(([t, d], i) => <article key={t} className={cx("rounded-[26px] p-6 lg:col-span-4", i % 3 === 0 ? "bg-[#071A2F] text-white" : i % 3 === 1 ? "bg-[#F4E8EC] text-[#071A2F]" : "border border-[#071A2F]/10 bg-white text-[#071A2F]")}><span className={cx("text-sm font-bold", i % 3 === 0 ? "text-[#D5AD57]" : "text-[#8B1E3F]")}>Studio 0{i + 1}</span><h3 className="mt-5 text-xl font-semibold">{t}</h3><p className={cx("mt-3 text-sm leading-7", i % 3 === 0 ? "text-white/60" : "text-[#132337]/60")}>{d}</p></article>)}<div className="flex flex-wrap items-center justify-between gap-5 rounded-[26px] bg-[#8B1E3F] p-7 text-white lg:col-span-12"><p className="text-xl font-semibold">{data.signature}</p><CTA dark href={href} /></div></div></Shell> }
function Education({ data, image, href }) { return <Shell bg="bg-[#F9F2F4]"><div className="grid gap-10 lg:grid-cols-[.95fr_1.05fr]"><div><Heading data={data} /><div className="mt-9"><CTA href={href} /></div></div><div className="relative space-y-4 before:absolute before:bottom-5 before:left-6 before:top-5 before:w-px before:bg-[#D5AD57]">{data.reasons.map(([t, d], i) => <article key={t} className="relative flex gap-5 rounded-2xl bg-white p-5 shadow-sm"><Icon index={i} /><div><h3 className="text-lg font-semibold text-[#071A2F]">{t}</h3><p className="mt-2 text-sm leading-7 text-[#132337]/60">{d}</p></div></article>)}</div></div><blockquote className="mt-10 border-y border-[#071A2F]/15 py-6 text-center text-2xl text-[#071A2F]">{data.signature}</blockquote></Shell> }
function Journalism({ data, image, href }) { return <Shell bg="bg-[#F4E8EC]"><div className="border-y-4 border-[#071A2F]"><div className=""><div className="p-7 sm:p-10"><span className="text-sm font-black uppercase tracking-[.18em] text-[#8B1E3F]">Special report</span><Heading data={data} /><div className="mt-8"><CTA href={href} /></div></div><aside className="bg-[#F7F2E8] p-7 sm:p-9"><p className="text-2xl font-semibold leading-9 text-[#071A2F]">{data.signature}</p></aside></div><div className="grid border-t border-[#071A2F]/15 md:grid-cols-3">{data.reasons.map(([t, d], i) => <article key={t} className="border-b border-[#071A2F]/15 p-5 md:border-r"><span className="text-sm font-bold text-[#8B1E3F]">Desk 0{i + 1}</span><h3 className="mt-3 text-lg font-semibold text-[#071A2F]">{t}</h3><p className="mt-2 text-sm leading-7 text-[#132337]/60">{d}</p></article>)}</div></div></Shell> }
function Hotel({ data, image, href }) {
    const hospitalityAdvantages = data.reasons.map(
        ([title, description], index) => ({
            number: String(index + 1).padStart(2, "0"),
            title,
            description,
        })
    );

    return (
        <section
            id="why-choose-hotel-management"
            aria-labelledby="why-choose-hotel-heading"
            className="relative isolate overflow-hidden bg-[#F4E8EC] py-20 text-[#132337] sm:py-24 lg:py-28"
        >
            {/* Background treatment */}
            <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_90%_14%,rgba(139,30,63,0.12),transparent_28%)]" />

                <div className="absolute -left-28 bottom-0 h-80 w-80 rounded-full bg-[#D5AD57]/10 blur-[90px]" />

                <div className="absolute -right-24 top-16 h-72 w-72 rounded-full bg-[#8B1E3F]/10 blur-[90px]" />

                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#8B1E3F]/30 to-transparent" />

                <div className="absolute -bottom-12 right-0 select-none text-[9rem] font-black leading-none tracking-[-0.08em] text-[#071A2F]/[0.025] sm:text-[14rem] lg:text-[19rem]">
                    WHY
                </div>
            </div>

            <div className="container relative z-[1] mx-auto">
                {/* Section heading */}
                <header className="grid gap-9 lg:grid-cols-[minmax(0,1.12fr)_minmax(320px,0.55fr)] lg:items-end lg:gap-[clamp(55px,9vw,145px)]">
                    <div>
                        <div className="mb-5 flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.16em] text-[#8B1E3F]">
                            <span className="h-0.5 w-[38px] bg-current" />
                            <span>The ISBM hospitality advantage</span>
                        </div>

                        <h2
                            id="why-choose-hotel-heading"
                            className="m-0 max-w-[900px] text-[clamp(42px,5vw,68px)] font-normal leading-[1.06] tracking-[-0.04em] text-[#071A2F]"
                            style={{
                                fontFamily:
                                    '"Libre Caslon Display", Georgia, serif',
                            }}
                        >
                            Why choose ISBM
                            <em className="font-normal text-[#8B1E3F]">
                                {" "}
                                Hotel Management School?
                            </em>
                        </h2>
                    </div>

                    <p className="m-0 border-l border-[#071A2F]/15 pl-7 text-base leading-8 text-[#586575] max-lg:border-l-0 max-lg:border-t max-lg:pt-7 sm:text-lg">
                        {data.lead ||
                            "Build professional expertise through academic learning, practical hospitality training, industry exposure and leadership-focused education designed for contemporary hospitality careers."}
                    </p>
                </header>

                {/* Main feature */}
                <div className="mt-16 grid overflow-hidden rounded-[8px_42px_8px_8px] border border-[#071A2F]/10 bg-white/70 shadow-[0_30px_90px_rgba(7,26,47,0.1)] backdrop-blur-xl lg:grid-cols-[0.82fr_1.18fr]">
                    {/* Dark editorial feature */}
                    <article className="relative overflow-hidden bg-[#071A2F] px-7 py-10 text-white sm:px-10 sm:py-12 lg:px-12 lg:py-14">
                        <div
                            className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full border border-white/10"
                            aria-hidden="true"
                        />

                        <div
                            className="pointer-events-none absolute -right-8 -top-8 h-40 w-40 rounded-full border border-[#D5AD57]/20"
                            aria-hidden="true"
                        />

                        <div
                            className="pointer-events-none absolute bottom-0 left-0 h-44 w-44 rounded-tr-full bg-[#8B1E3F]/20"
                            aria-hidden="true"
                        />

                        <div className="relative flex h-full flex-col">
                            <span className="text-sm font-extrabold uppercase tracking-[0.16em] text-[#D5AD57]">
                                Learning beyond the classroom
                            </span>

                            <h3
                                className="mt-6 max-w-md text-[clamp(32px,3.2vw,46px)] font-normal leading-[1.15]"
                                style={{
                                    fontFamily:
                                        '"Libre Caslon Display", Georgia, serif',
                                }}
                            >
                                Professional hospitality education shaped by
                                practice.
                            </h3>

                            <p className="mt-6 max-w-lg text-base leading-8 text-[#AAB6C2]">
                                Students gain exposure to hotel operations, food
                                production, restaurant service, guest relations,
                                front-office management, tourism and service
                                leadership within a professionally structured
                                academic environment.
                            </p>

                            <div className="mt-10 grid grid-cols-2 border-l border-t border-white/15">
                                {[
                                    ["Practical", "Training"],
                                    ["Industry", "Orientation"],
                                    ["Career", "Readiness"],
                                    ["Service", "Leadership"],
                                ].map(([title, subtitle]) => (
                                    <div
                                        key={`${title}-${subtitle}`}
                                        className="min-h-[115px] border-b border-r border-white/15 p-5 transition duration-300 hover:bg-white/[0.045]"
                                    >
                                        <strong
                                            className="block text-xl font-normal text-white"
                                            style={{
                                                fontFamily:
                                                    '"Libre Caslon Display", Georgia, serif',
                                            }}
                                        >
                                            {title}
                                        </strong>

                                        <span className="mt-2 block text-xs font-bold uppercase tracking-[0.1em] text-[#D5AD57]">
                                            {subtitle}
                                        </span>
                                    </div>
                                ))}
                            </div>

                            <blockquote className="mt-9 border-l-2 border-[#D5AD57] pl-5 text-xl leading-8 text-white">
                                “{data.signature}”
                            </blockquote>

                            <div className="mt-auto pt-10">
                                <CTA dark href={href} />
                            </div>
                        </div>
                    </article>

                    {/* Hospitality advantages */}
                    <div className="grid sm:grid-cols-2">
                        {hospitalityAdvantages.map((item, index) => (
                            <article
                                key={item.number}
                                className={`group relative min-h-[275px] border-b border-[#071A2F]/10 p-7 transition duration-300 hover:bg-[#F7F2E8] sm:p-8 ${index % 2 === 0
                                    ? "sm:border-r"
                                    : ""
                                    }`}
                            >
                                <span className="text-sm font-extrabold text-[#A77B2D]">
                                    {item.number}
                                </span>

                                <h3
                                    className="mt-7 max-w-[300px] text-2xl font-normal leading-[1.25] text-[#071A2F] transition duration-300 group-hover:text-[#8B1E3F]"
                                    style={{
                                        fontFamily:
                                            '"Libre Caslon Display", Georgia, serif',
                                    }}
                                >
                                    {item.title}
                                </h3>

                                <p className="mt-4 text-sm leading-7 text-[#65717D]">
                                    {item.description}
                                </p>

                                <div className="mt-7 h-px w-10 bg-[#8B1E3F] transition-all duration-300 group-hover:w-20" />

                                <span
                                    className="pointer-events-none absolute right-6 top-5 text-6xl font-normal text-[#071A2F]/[0.035]"
                                    style={{
                                        fontFamily:
                                            '"Libre Caslon Display", Georgia, serif',
                                    }}
                                    aria-hidden="true"
                                >
                                    {item.number}
                                </span>
                            </article>
                        ))}
                    </div>
                </div>

                {/* Bottom statement */}
                <div className="mt-10 grid overflow-hidden rounded-[7px_28px_7px_7px] border border-[#071A2F]/10 bg-[#EEE5D3] sm:grid-cols-[1fr_auto] sm:items-center">
                    <div className="flex items-start gap-4 px-6 py-6 sm:px-8">
                        <div className="mt-1 grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#8B1E3F] text-sm font-bold text-white">
                            ✓
                        </div>

                        <div>
                            <p
                                className="m-0 text-xl font-normal text-[#071A2F]"
                                style={{
                                    fontFamily:
                                        '"Libre Caslon Display", Georgia, serif',
                                }}
                            >
                                A career-focused academic experience
                            </p>

                            <p className="mt-2 text-sm leading-7 text-[#65717D]">
                                Combining academic knowledge, practical
                                competence, professional values and
                                service-oriented leadership.
                            </p>
                        </div>
                    </div>

                    <div className="border-t border-[#071A2F]/10 px-6 py-5 sm:border-l sm:border-t-0 sm:px-8">
                        <a
                            href="/apply-online"
                            className="inline-flex min-h-[52px] items-center justify-center gap-5 rounded-full bg-[#071A2F] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-white transition duration-300 hover:-translate-y-1 hover:bg-[#8B1E3F] focus:outline-none focus:ring-2 focus:ring-[#D5AD57] focus:ring-offset-2 focus:ring-offset-[#EEE5D3]"
                        >
                            Apply now
                            <span aria-hidden="true">↗</span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
function Media({ data, image, href }) { return <Shell bg="bg-[#F4E8EC]"><div className="grid gap-8 lg:grid-cols-[.8fr_1.2fr]"><div className="rounded-[32px] bg-white p-7 sm:p-10"><span className="flex items-center gap-3 text-sm font-bold uppercase tracking-[.16em] text-[#8B1E3F]"><span className="h-3 w-3 rounded-full bg-[#8B1E3F]" />Now in production</span><h2 className="mt-7 text-[clamp(40px,5vw,64px)] font-normal leading-[1.03] text-[#071A2F]" style={{ fontFamily: '"Libre Caslon Display",Georgia,serif' }}>Why choose ISBM <em className="font-normal text-[#8B1E3F]">{data.name} School?</em></h2><p className="mt-6 text-lg leading-8 text-[#132337]/65">{data.lead}</p><p className="mt-8 text-xl font-semibold text-[#071A2F]">{data.signature}</p><div className="mt-8"><CTA href={href} /></div></div><div className="grid grid-cols-2 gap-4">{data.reasons.map(([t, d], i) => <article key={t} className={cx("rounded-[26px] p-5", i === 5 ? "col-span-2 bg-[#071A2F] text-white" : i === 0 ? "col-span-2 bg-[#071A2F] text-white" : i % 2 ? "bg-[#D5AD57] text-[#071A2F]" : "bg-white text-[#071A2F]")}><span className={cx("text-sm font-bold", i === 5 ? "text-[#D5AD57]" : i === 0 ? "text-[#D5AD57]" : "text-[#8B1E3F]")}>Take 0{i + 1}</span><h3 className="mt-4 text-lg font-semibold">{t}</h3><p className={cx("mt-2 text-sm leading-7", i === 5 ? "text-white/60" : i === 0 ? "text-white/60" : "text-[#132337]/60")}>{d}</p></article>)}</div></div></Shell> }
function Library({ data, image, href }) { return <Shell bg="bg-white"><div className="grid border border-[#071A2F]/15 lg:grid-cols-[270px_1fr]"><aside className="bg-[#F7F2E8] p-7"><span className="text-sm font-bold uppercase tracking-[.15em] text-[#8B1E3F]">Knowledge index</span><div className="mt-8 space-y-5">{data.reasons.map(([t], i) => <a key={t} href={`#reason-${i}`} className="block border-b border-[#071A2F]/10 pb-3 text-sm font-semibold text-[#071A2F]">00{i + 1} · {t}</a>)}</div></aside><div className="p-7 sm:p-10 lg:p-12"><Heading data={data} /><div className="mt-9 grid gap-5 sm:grid-cols-2">{data.reasons.map(([t, d], i) => <article id={`reason-${i}`} key={t}><span className="text-sm font-bold text-[#8B1E3F]">Record 00{i + 1}</span><h3 className="mt-2 text-lg font-semibold text-[#071A2F]">{t}</h3><p className="mt-2 text-sm leading-7 text-[#132337]/60">{d}</p></article>)}</div><div className="mt-9 flex flex-wrap items-center justify-between gap-5 border-t border-[#071A2F]/15 pt-7"><p className="text-xl font-semibold text-[#071A2F]">{data.signature}</p><CTA href={href} /></div></div></div></Shell> }
function Yoga({ data, image, href }) {
    const learningDimensions = [
        {
            label: "Foundation",
            title: data.reasons[0]?.[0],
            description: data.reasons[0]?.[1],
        },
        {
            label: "Knowledge",
            title: data.reasons[1]?.[0],
            description: data.reasons[1]?.[1],
        },
        {
            label: "Wellbeing",
            title: data.reasons[2]?.[0],
            description: data.reasons[2]?.[1],
        },
        {
            label: "Application",
            title: data.reasons[3]?.[0],
            description: data.reasons[3]?.[1],
        },
        {
            label: "Lifestyle",
            title: data.reasons[4]?.[0],
            description: data.reasons[4]?.[1],
        },
        {
            label: "Professional practice",
            title: data.reasons[5]?.[0],
            description: data.reasons[5]?.[1],
        },
    ].filter((item) => item.title);

    return (
        <section
            id="why-choose-yoga"
            className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-28"
            aria-labelledby="why-yoga-heading"
        >
            {/* Calm architectural background */}
            <div
                className="pointer-events-none absolute inset-0"
                aria-hidden="true"
            >
                <div className="absolute -left-44 top-20 h-[480px] w-[480px] rounded-full border border-[#D5AD57]/25" />

                <div className="absolute -left-24 top-40 h-[280px] w-[280px] rounded-full border border-[#8B1E3F]/10" />

                <div className="absolute -right-40 bottom-0 h-[520px] w-[520px] rounded-full bg-[#D5AD57]/10 blur-[110px]" />

                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D5AD57] to-transparent" />

                <div className="absolute right-[7%] top-0 h-full w-px bg-[#071A2F]/[0.04]" />
            </div>

            <div className="relative mx-auto max-w-[1380px] px-5 sm:px-8 lg:px-10">
                {/* Section heading */}
                <div className="grid gap-10 lg:grid-cols-[1.08fr_0.92fr] lg:items-end">
                    <div>
                        <div className="flex items-center gap-4">
                            <span className="h-px w-12 bg-[#8B1E3F]" />

                            <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                The ISBM holistic education advantage
                            </span>
                        </div>

                        <h2
                            id="why-yoga-heading"
                            className="mt-6 max-w-5xl text-[clamp(42px,5.5vw,72px)] font-normal leading-[1.03] tracking-[-0.04em] text-[#071A2F]"
                            style={{
                                fontFamily:
                                    '"Libre Caslon Display", Georgia, serif',
                            }}
                        >
                            Why choose ISBM
                            <em className="block font-normal text-[#8B1E3F]">
                                Yoga &amp; Naturopathy School?
                            </em>
                        </h2>
                    </div>

                    <div className="border-l border-[#071A2F]/15 pl-7 max-lg:border-l-0 max-lg:border-t max-lg:pt-7">
                        <p className="text-base leading-8 text-[#132337]/65 sm:text-lg">
                            {data.lead ||
                                "Study holistic wellbeing through classical knowledge, disciplined practice, scientific understanding and responsible professional preparation."}
                        </p>

                        <div className="mt-7">
                            <CTA href={href} />
                        </div>
                    </div>
                </div>

                {/* Main academic composition */}
                <div className="mt-14 grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
                    {/* Image and proposition */}
                    <div className="relative min-h-[650px] overflow-hidden rounded-[180px_8px_8px_8px] bg-[#071A2F]">
                        <Image
                            src={image}
                            alt={`${data.name} academic learning environment`}
                            className="min-h-[650px]"
                        />

                        <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F] via-[#071A2F]/25 to-transparent" />

                        <div className="absolute inset-0 bg-gradient-to-r from-[#071A2F]/25 via-transparent to-transparent" />

                        {/* Image framing */}
                        <span className="absolute left-8 top-8 h-16 w-16 rounded-tl-[52px] border-l border-t border-[#D5AD57]/70" />

                        <span className="absolute bottom-8 right-8 h-16 w-16 border-b border-r border-[#D5AD57]/70" />

                        <div className="absolute inset-x-0 bottom-0 p-7 sm:p-10">
                            <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                An integrated learning environment
                            </span>

                            <blockquote
                                className="mt-5 max-w-xl text-[clamp(28px,3vw,42px)] font-normal leading-[1.2] text-white"
                                style={{
                                    fontFamily:
                                        '"Libre Caslon Display", Georgia, serif',
                                }}
                            >
                                “{data.signature}”
                            </blockquote>

                            <p className="mt-5 max-w-lg text-base leading-8 text-white/65">
                                Classical traditions are studied through
                                disciplined academic enquiry, guided practice and
                                a responsible understanding of health and
                                wellbeing.
                            </p>
                        </div>
                    </div>

                    {/* Academic dimensions */}
                    <div className="overflow-hidden border border-[#071A2F]/10 bg-[#F7F2E8]">
                        <div className="border-b border-[#071A2F]/15 bg-[#071A2F] p-7 text-white sm:p-9">
                            <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                Academic learning framework
                            </span>

                            <h3
                                className="mt-4 max-w-2xl text-3xl font-normal leading-[1.2] sm:text-4xl"
                                style={{
                                    fontFamily:
                                        '"Libre Caslon Display", Georgia, serif',
                                }}
                            >
                                Knowledge, practice and professional
                                responsibility.
                            </h3>
                        </div>

                        <div className="grid sm:grid-cols-2">
                            {learningDimensions.map((item, index) => (
                                <article
                                    key={item.title}
                                    className={`group relative min-h-[255px] border-b border-[#071A2F]/10 p-6 transition duration-300 hover:bg-white sm:p-7 ${index % 2 === 0 ? "sm:border-r" : ""
                                        }`}
                                >
                                    <div className="flex items-start justify-between gap-4">
                                        <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">
                                            {item.label}
                                        </span>

                                        <span
                                            className="text-4xl font-normal text-[#071A2F]/10 transition duration-300 group-hover:text-[#8B1E3F]/20"
                                            style={{
                                                fontFamily:
                                                    '"Libre Caslon Display", Georgia, serif',
                                            }}
                                        >
                                            {String(index + 1).padStart(2, "0")}
                                        </span>
                                    </div>

                                    <h4
                                        className="mt-7 text-2xl font-normal leading-8 text-[#071A2F] transition duration-300 group-hover:text-[#8B1E3F]"
                                        style={{
                                            fontFamily:
                                                '"Libre Caslon Display", Georgia, serif',
                                        }}
                                    >
                                        {item.title}
                                    </h4>

                                    <p className="mt-4 text-sm leading-7 text-[#132337]/60">
                                        {item.description}
                                    </p>

                                    <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-gradient-to-r from-[#8B1E3F] to-[#D5AD57] transition-all duration-300 group-hover:w-full" />
                                </article>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Learning progression */}
                <div className="mt-8 grid overflow-hidden border border-[#071A2F]/10 bg-white md:grid-cols-[300px_1fr]">
                    <div className="bg-[#8B1E3F] p-7 text-white sm:p-8">
                        <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                            Student progression
                        </span>

                        <p
                            className="mt-4 text-2xl font-normal leading-8"
                            style={{
                                fontFamily:
                                    '"Libre Caslon Display", Georgia, serif',
                            }}
                        >
                            A considered journey from knowledge to responsible
                            practice.
                        </p>
                    </div>

                    <div className="grid sm:grid-cols-2 lg:grid-cols-4">
                        {[
                            {
                                number: "01",
                                title: "Understand",
                                text: "Study philosophy, human wellbeing and classical foundations.",
                            },
                            {
                                number: "02",
                                title: "Practise",
                                text: "Develop consistency through guided practical learning.",
                            },
                            {
                                number: "03",
                                title: "Apply",
                                text: "Connect knowledge with holistic health contexts.",
                            },
                            {
                                number: "04",
                                title: "Serve",
                                text: "Practise with responsibility, awareness and professional ethics.",
                            },
                        ].map((stage, index) => (
                            <article
                                key={stage.title}
                                className={`group p-6 transition duration-300 hover:bg-[#F7F2E8] ${index < 3
                                        ? "border-b border-[#071A2F]/10 sm:border-r lg:border-b-0"
                                        : ""
                                    } ${index === 1
                                        ? "sm:border-r-0 lg:border-r"
                                        : ""
                                    }`}
                            >
                                <span className="text-sm font-bold text-[#8B1E3F]">
                                    {stage.number}
                                </span>

                                <h3
                                    className="mt-4 text-2xl font-normal text-[#071A2F]"
                                    style={{
                                        fontFamily:
                                            '"Libre Caslon Display", Georgia, serif',
                                    }}
                                >
                                    {stage.title}
                                </h3>

                                <p className="mt-3 text-sm leading-7 text-[#132337]/60">
                                    {stage.text}
                                </p>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
function LifeScience({ data, image, href }) { return <Shell bg="bg-white"><div className="grid gap-10 lg:grid-cols-[1fr_.9fr]"><div><Heading data={data} /><div className="relative mt-10 space-y-4 before:absolute before:bottom-6 before:left-6 before:top-6 before:w-px before:bg-[#8B1E3F]/25">{data.reasons.map(([t, d], i) => <article key={t} className={cx("relative flex gap-5 rounded-[26px] p-5", i % 2 ? "ml-8 bg-[#F4E8EC]" : "mr-8 bg-[#F7F2E8]")}><Icon index={i} /><div><h3 className="text-lg font-semibold text-[#071A2F]">{t}</h3><p className="mt-2 text-sm leading-7 text-[#132337]/60">{d}</p></div></article>)}</div></div><aside className="overflow-hidden rounded-[220px_220px_30px_30px] bg-[#071A2F] lg:sticky lg:top-24 lg:self-start"><Image src={image} alt={data.name} /><div className="p-7 text-center text-white"><p className="text-xl font-semibold">{data.signature}</p><div className="mt-5"><CTA dark href={href} /></div></div></aside></div></Shell> }
function Vocational({ data, image, href }) { return <Shell bg="bg-[#F7F2E8]"><Heading data={data} /><div className="mt-12 grid gap-5 lg:grid-cols-[1fr_260px_1fr] lg:items-center"><div className="space-y-4">{data.reasons.slice(0, 3).map(([t, d], i) => <Skill key={t} t={t} d={d} i={i} />)}</div><div className="rounded-[28px] bg-[#8B1E3F] p-7 text-center text-white"><span className="text-sm font-bold uppercase tracking-wider text-[#D5AD57]">Career outcome</span><p className="mt-5 text-2xl font-semibold leading-8">{data.signature}</p><div className="mt-6"><CTA dark href={href} /></div></div><div className="space-y-4">{data.reasons.slice(3).map(([t, d], i) => <Skill key={t} t={t} d={d} i={i + 3} />)}</div></div></Shell> }
function Skill({ t, d, i }) { return <article className="rounded-[24px] border border-[#071A2F]/10 bg-white p-5"><div className="flex gap-4"><Icon index={i} /><div><h3 className="text-lg font-semibold text-[#071A2F]">{t}</h3><p className="mt-2 text-sm leading-7 text-[#132337]/60">{d}</p></div></div></article> }
function Health({ data, image, href }) { return <Shell bg="bg-[#F9F2F4]"><div className="grid overflow-hidden rounded-[34px] bg-white shadow-[0_24px_70px_rgba(7,26,47,.09)] lg:grid-cols-[.85fr_1.15fr]"><div className="relative"><Image src={image} alt={data.name} className="min-h-[680px]" /><div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/80 to-transparent" /><p className="absolute bottom-7 left-7 right-7 text-2xl font-semibold text-white">{data.signature}</p></div><div className="p-7 sm:p-10 lg:p-12"><Heading data={data} /><div className="mt-9 divide-y divide-[#071A2F]/10">{data.reasons.map(([t, d], i) => <article key={t} className="flex gap-4 py-4 first:pt-0"><Icon index={i} /><div><h3 className="text-lg font-semibold text-[#071A2F]">{t}</h3><p className="mt-2 text-sm leading-7 text-[#132337]/60">{d}</p></div></article>)}</div><div className="mt-8"><CTA href={href} /></div></div></div></Shell> }

const COMPONENTS = {
    "school-of-management": Management,
    "school-of-commerce": Commerce,
    "school-of-engineering-and-technology": Engineering,
    "school-of-information-and-technology": IT,
    "school-of-science": Science,
    "school-of-arts-and-humanities": Arts,
    "school-of-law": Law,
    "school-of-pharmacy": Pharmacy,
    "school-of-design": Design,
    "school-of-education": Education,
    "school-of-journalism-and-mass-communication": Journalism,
    "school-of-hotel-management": Hotel,
    "school-of-media-and-entertainment": Media,
    "school-of-library-and-information-science": Library,
    "school-of-yoga-and-naturopathy": Yoga,
    "school-of-life-science": LifeScience,
    "school-of-vocational-management": Vocational,
    "school-of-health-and-allied-science": Health
};

export default function WhyChooseSchool({ school, schoolDetails, image, href = "#academic-programs" }) {
    const object = typeof school === "object" && school !== null ? school : schoolDetails;
    const schoolId = typeof school === "string" ? school : object?.id;
    const Component = COMPONENTS[schoolId];
    const defaults = WHY_CHOOSE_DATA[schoolId];
    if (!Component || !defaults) return null;
    const data = { ...defaults, ...(object?.whyChoose || {}) };
    return <Component data={data} image={image || object?.why_choose_image || object?.banner} href={href} />;
}

export { WHY_CHOOSE_DATA as whyChooseSchoolContent };
